/** 建築物情報 */
export interface Building {
  /** 建物ID */
  buildingId: string | undefined
  /** 建物の緯度経度(JGD2011) */
  location: [number, number] | undefined
  /** 空間検索用クアッドキー */
  quadkey: string | undefined
  /** GeoJSONの形状の型 */
  shapeType: string | undefined
  /** 形状 */
  shapeCoordinates: number[][][][] | undefined
}

/** 空の建築物情報 */
export const EMPTY_BUILDIND: Building = {
  buildingId: '',
  location: undefined,
  quadkey: '',
  shapeCoordinates: [],
  shapeType: undefined
}
